import React, { useEffect, useState } from 'react';
import { misc } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Trophy, Sparkles, Loader2 } from 'lucide-react';
import SiteSections from '../components/SiteSections';
import { TopReadersBoard } from '../components/TopReadersBoard';

export default function Leaderboard() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { misc.leaderboard().then(setList).finally(() => setLoading(false)); }, []);

  const you = { rank: '—', name: user?.name || 'You', points: user?.points || 0, avatar: user?.avatar };

  if (loading) return <div className="flex items-center gap-2 text-gray-400"><Loader2 className="animate-spin" size={16}/> Loading...</div>;

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-2xl font-bold">Community Leaderboard</h1>
        <p className="text-gray-400 text-sm">Real-time ranking of PBB point earners. Updated live.</p>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {list.slice(0,3).map((l, i) => (
          <div key={l.rank} className={`pbb-card p-5 text-center ${i===0 ? 'ring-2 ring-green-500' : ''}`}>
            <div className="flex justify-center mb-2">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${i===0?'bg-yellow-500/20 text-yellow-400':i===1?'bg-gray-500/20 text-gray-300':'bg-orange-500/20 text-orange-400'}`}><Trophy size={18}/></div>
            </div>
            <img src={l.avatar} alt="" className="w-14 h-14 rounded-full mx-auto object-cover" />
            <div className="font-semibold mt-2">{l.name}</div>
            <div className="text-green-400 text-sm">{l.points.toLocaleString()} pts</div>
            <div className="text-xs text-gray-500 mt-1">#{l.rank}</div>
          </div>
        ))}
      </div>
      {list.length === 0 && (
        <div className="pbb-card border-2 border-dashed border-green-500/30 bg-green-500/5 p-10 text-center" data-testid="leaderboard-empty-state">
          <Trophy className="mx-auto text-green-400" size={30} />
          <h3 className="mt-4 text-xl font-bold">Leaderboard fills up with our founding 100</h3>
          <p className="mt-2 text-sm text-gray-300 max-w-md mx-auto">Register today, start earning points, and stake your claim as one of the first names on the PBB leaderboard.</p>
          <a href="/signup" data-testid="leaderboard-empty-cta" className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-green-600 hover:bg-green-500 text-white text-sm font-semibold">Register Free</a>
        </div>
      )}
      <div className="pbb-card p-4">
        <ul className="divide-y divide-[#1f1f1f]">
          {list.slice(3).map(l => (
            <li key={l.rank} className="flex items-center gap-3 py-3">
              <div className="w-8 text-gray-400 text-sm">#{l.rank}</div>
              <img src={l.avatar} alt="" className="w-10 h-10 rounded-full object-cover" />
              <div className="flex-1">
                <div className="font-medium text-sm">{l.name}</div>
              </div>
              <div className="text-green-400 text-sm font-medium">{l.points.toLocaleString()} pts</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="pbb-card p-4 border-green-600/40 bg-green-600/5">
        <div className="flex items-center gap-3">
          <Sparkles className="text-green-400" size={18}/>
          <img src={you.avatar} alt="" className="w-10 h-10 rounded-full object-cover"/>
          <div className="flex-1">
            <div className="text-sm font-medium">{you.name}</div>
            <div className="text-xs text-gray-400">Your rank updates in real time</div>
          </div>
          <div className="text-green-400 font-semibold">{you.points.toLocaleString()} pts</div>
        </div>
      </div>
      <TopReadersBoard meId={user?.id} />
      <SiteSections pageKey="leaderboard" />
    </div>
  );
}
